// @ts-strict-ignore FIXME: type method params
import { setup } from 'APP/BrownfieldBridge/BrownfieldBridgeInternal'
import * as BrownfieldBridgeExternal from 'APP/BrownfieldBridge/BrownfieldBridgeExternal'
import { handlePushNotificationFromBridge } from 'APP/Lib/NotificationHelpers'

export async function startBrownfield() {
  // Setup Brownfield bridge module handlers
  setup({
    openUrl: (params) => {
      BrownfieldBridgeExternal.triggerOpenUrl(params)
    },
    openDeeplink: (params) => {
      BrownfieldBridgeExternal.triggerOpenDeeplink(params)
    },
    registerPushToken: (params) => {
      const { token, requestId } = params
      BrownfieldBridgeExternal.triggerRegisterPushToken({ token, requestId })
    },
    registerVoipPushToken: (params) => {
      const { token, requestId } = params
      BrownfieldBridgeExternal.triggerRegisterVoipPushToken({ token, requestId })
    },
    logout: (params) => {
      BrownfieldBridgeExternal.triggerLogout(params)
    },
    preload: () => {
      BrownfieldBridgeExternal.triggerPreload()
    },
    handlePushNotification: ([userInfo]) => {
      handlePushNotificationFromBridge(userInfo)
    },
    resolveDeeplink: (params) => {
      BrownfieldBridgeExternal.triggerResolveDeeplink(params)
    },
  })
}
